import ChapelList from '../layout/Admin/ChapelList';
import { useMasterData } from '../../hooks/api/useMasterData';
import ChapelOptionSorting from '../common/option-sorting/ChapelOptionSorting';
// import socketSetup from '../../../socket-io/socket-io';

export default function Chapel() {

    const {
        chapelsAvailable,
        isErrorChapelsAvailable,
        isLoadingChapelsAvailable,
        errorMessageChapelsAvailable,
    } = useMasterData()

    // useEffect(() => {
    //     socketSetup.on('newChapelCreated', refetchChapelsAvailable);

    //     return () => {
    //         socketSetup.off("newChapelCreated");
    //     };
    // }, [refetchChapelsAvailable]);

    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-3 overflow-hidden'>
            <ChapelOptionSorting/>
            <ChapelList
                data={chapelsAvailable}
                isLoading={isLoadingChapelsAvailable}
                isError={isErrorChapelsAvailable}
                errorMessage={errorMessageChapelsAvailable}
            />
        </div>
    )
}
